module.exports = require("core-js-pure/features/promise");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/promise.js
// module id = 494
// module chunks = 13